import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=75a18a78&"
import script from "./Tips.vue?vue&type=script&lang=js&"
export * from "./Tips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports